import { createStackNavigator } from '@react-navigation/stack'
import * as React from 'react'
import { documentTitle } from '../../static/Routes'

const Stack = createStackNavigator()
const WhyJioSection = React.lazy(() => import('../../screens/WhyJio/Sections'))

const WhyJioSectionStack = () => {
  return (
    <>
      <Stack.Screen
        name={'widen-presence'}
        component={() => <WhyJioSection id="presence" />}
        options={{
          title: documentTitle.products,
        }}
      />
      <Stack.Screen
        name={'mitigate-risk'}
        component={() => <WhyJioSection id="secure" />}
        options={{
          title: documentTitle.products,
        }}
      />
      <Stack.Screen
        name={'simplified-experience'}
        component={() => <WhyJioSection id="experience" />}
        options={{
          title: documentTitle.products,
        }}
      />
      <Stack.Screen
        name={'increase-conversion'}
        component={() => <WhyJioSection id="conversion" />}
        options={{
          title: documentTitle.products,
        }}
      />
    </>
  )
}

export default WhyJioSectionStack
